var _defs, _rect, _rect2, _line, _line2, _rect3, _rect4, _rect5, _line3, _line4, _line5, _line6, _rect6, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyTemplates(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gold2",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#E5C77D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "45%",
    stopColor: "#C8A55B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#9C7E3F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "goldSoft2",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#E5C77D",
    stopOpacity: 0.14
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#C8A55B",
    stopOpacity: 0.05
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 52,
    width: 76,
    height: 100,
    rx: 8,
    fill: "none",
    stroke: "url(#gold2)",
    strokeWidth: 1.5,
    strokeOpacity: 0.25,
    transform: "rotate(-6 114 102)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 56,
    width: 76,
    height: 100,
    rx: 8,
    fill: "url(#goldSoft2)",
    stroke: "url(#gold2)",
    strokeWidth: 1.5,
    strokeOpacity: 0.45,
    transform: "rotate(-2 100 106)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 75,
    y1: 82,
    x2: 124,
    y2: 80,
    stroke: "url(#gold2)",
    strokeWidth: 1,
    strokeOpacity: 0.2,
    transform: "rotate(-2 100 106)"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 75,
    y1: 92,
    x2: 118,
    y2: 90,
    stroke: "url(#gold2)",
    strokeWidth: 1,
    strokeOpacity: 0.2,
    transform: "rotate(-2 100 106)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 60,
    width: 84,
    height: 108,
    rx: 9,
    fill: "url(#goldSoft2)",
    stroke: "url(#gold2)",
    strokeWidth: 1.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 60,
    width: 84,
    height: 28,
    rx: 9,
    fill: "url(#gold2)",
    fillOpacity: 0.12
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 79,
    width: 84,
    height: 9,
    fill: "url(#gold2)",
    fillOpacity: 0.08
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 68,
    y1: 105,
    x2: 124,
    y2: 105,
    stroke: "url(#gold2)",
    strokeWidth: 1.2,
    strokeOpacity: 0.35,
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 68,
    y1: 117,
    x2: 116,
    y2: 117,
    stroke: "url(#gold2)",
    strokeWidth: 1.2,
    strokeOpacity: 0.25,
    strokeLinecap: "round"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 68,
    y1: 129,
    x2: 120,
    y2: 129,
    stroke: "url(#gold2)",
    strokeWidth: 1.2,
    strokeOpacity: 0.25,
    strokeLinecap: "round"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 68,
    y1: 141,
    x2: 108,
    y2: 141,
    stroke: "url(#gold2)",
    strokeWidth: 1.2,
    strokeOpacity: 0.2,
    strokeLinecap: "round"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 66,
    width: 44,
    height: 5,
    rx: 2.5,
    fill: "url(#gold2)",
    fillOpacity: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M142 52 L144 46 L146 52 L152 50 L146 56 L144 62 L142 56 L136 54 Z",
    fill: "url(#gold2)",
    fillOpacity: 0.8,
    stroke: "url(#gold2)",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59 58 L60 55 L61 58 L64 57 L61 60 L60 63 L59 60 L56 59 Z",
    fill: "url(#gold2)",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyTemplates);
export default __webpack_public_path__ + "static/media/empty-templates.74c5c65fb9b60a04520be4efc4fc1324.svg";
export { ForwardRef as ReactComponent };